<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-row>
          <b-col md="4" class="my-1">
            <b-navbar-nav>
              <b-button @click="goBack" size="sm" class="ml-2 mr-2" variant="outline-secondary"
                style="font-size: 0.675rem">
                <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
              </b-button>
            </b-navbar-nav>
            <h5 class="mt-1 mr-2">
              {{ $route.name }}
            </h5>
          </b-col>
          <b-col md="2">
            <h5>
              <small v-if="isLoading == false">{{ totalData }} Entries</small>
            </h5>
          </b-col>
          <b-col md="6">
            <b-button class="pull-right ml-1 mt-1" :variant="Filter.DateTypeFilter ||
              Filter.ModuleTypeFilter ||
              Filter.PaymentTypeFilter ||
              Filter.JobNoFilter ||
              Filter.TransactionNoFilter ||
              Filter.clientFilter ||
              Filter.slineFilter ||
              Filter.TransportTypeFilter ||
              Filter.ShipemntTypeFilter ||
              Filter.PORFilter ||
              Filter.POLFilter ||
              Filter.PODFilter ||
              Filter.FPODFilter ||
              Filter.statusFilter ||
              Filter.commonFilter ||
              Filter.createdByFilter ||
              Filter.approverByFilter ||
              Filter.branchFilter ||
              Filter.dateRange.startDate ||
              Filter.dateRange.endDate
              ? 'outline-danger'
              : 'outline-primary'
              " :class="' ml-4' + visible ? null : 'collapsed'" :aria-expanded="visible ? 'true' : 'false'"
              aria-controls="collapse-4" @click="visible = !visible" style="font-size: 0.675rem">{{
                Filter.DateTypeFilter ||
                  Filter.ModuleTypeFilter ||
                  Filter.PaymentTypeFilter ||
                  Filter.JobNoFilter ||
                  Filter.TransactionNoFilter ||
                  Filter.clientFilter ||
                  Filter.slineFilter ||
                  Filter.TransportTypeFilter ||
                  Filter.ShipemntTypeFilter ||
                  Filter.PORFilter ||
                  Filter.POLFilter ||
                  Filter.PODFilter ||
                  Filter.FPODFilter ||
                  Filter.statusFilter ||
                  Filter.commonFilter ||
                  Filter.createdByFilter ||
                  Filter.approverByFilter ||
                  Filter.branchFilter ||
                  Filter.dateRange.startDate ||
                  Filter.dateRange.endDate
                  ? "Filter ON"
                  : "Filter OFF"
              }}</b-button>
            <b-button class="pull-right ml-1 mt-1" v-if="paymentList.length > 0"
              :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
              @click="getReports('getPaymentList', 'Export As Excel')" size="sm" variant="warning"
              style="font-size: 0.675rem">
              {{ ExcelBtnName }}
              <b-spinner v-if="ExcelBtnName != 'Export As Excel'" small label="Small Spinner"></b-spinner></b-button>

            <!-- Client-side Export using xlsx (exports current paymentList) -->
            <b-button class="pull-right ml-1 mt-1" v-if="paymentList.length > 0"
              @click="exportApprovalToExcelClient" size="sm" variant="success"
              style="font-size: 0.675rem">
              Export (Client XLSX)
            </b-button>

          </b-col>

          <b-col cols="12">
            <div>
              <b-pagination limit="25" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
                :total-rows="totalData" @change="onPageChange($event)"></b-pagination>
            </div>
          </b-col>
        </b-row>
        <div v-if="visible">
          <b-card>
            <b-collapse v-model="visible" id="collapse-2">
              <b-row>
                <b-col md="3">
                  <label>Date Type</label>
                  <model-list-select :list="dateTypeList" v-model="Filter.DateTypeFilter" option-value="value"
                    option-text="text" placeholder="Select Date Type"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Date</label>
                  <date-range-picker :always-show-calendars="showCal" v-model="Filter.dateRange" :startDate="startDate"
                    :endDate="endDate" :locale-data="locale" :disabled="Filter.DFlag ? true : false"
                    @update="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Module Type</label>
                  <model-list-select :list="moduleOptions" v-model="Filter.ModuleTypeFilter" option-value="Val"
                    option-text="Text" placeholder="Select Module Type"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Payment Type</label>
                  <model-list-select :list="payTypeOptions" v-model="Filter.PaymentTypeFilter" option-value="Val"
                    option-text="Text" placeholder="Select Payment Type"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Status</label>
                  <model-list-select :list="statusList" v-model="Filter.statusFilter" option-value="value"
                    option-text="text" placeholder="Select Status"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Job NO Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Job NO Filter"
                    id="JobNoFilter" name="JobNoFilter" autocomplete="off" v-model="Filter.JobNoFilter"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Transaction No Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Transaction No Filter"
                    id="TransactionNoFilter" name="TransactionNoFilter" autocomplete="off"
                    v-model="Filter.TransactionNoFilter" @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Transport Type</label>
                  <model-list-select :list="transportTypeList" v-model="Filter.TransportTypeFilter" option-value="value"
                    option-text="value" placeholder="Select Transport Type"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>

                <b-col md="3">
                  <label>Shipment Type</label>
                  <model-list-select :list="shipmentTypeList" v-model="Filter.ShipemntTypeFilter" option-value="value"
                    option-text="value" placeholder="Select Shipment Type"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>

                <b-col md="3">
                  <label>Shipping Line</label>
                  <model-list-select :list="$store.getters['common/getAllShippingLineList']"
                    v-model="Filter.slineFilter" option-value="shippingId" option-text="shippingLine"
                    placeholder="Select Shipping Line" @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Client</label>
                  <model-list-select :list="$store.getters['common/getAllClientList']" id="clientFilter"
                    v-model="Filter.clientFilter" option-value="clientId" option-text="clientName"
                    placeholder="Select Client Name" @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Branch</label>
                  <model-list-select :list="$store.getters['common/getAllBranchList']" id="branchfilter"
                    v-model="Filter.branchFilter" option-value="pickupId" option-text="pickupLocation" placeholder="All"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>

                <b-col md="3">
                  <label>POR</label>
                  <model-list-select :list="$store.getters['common/getAllPORList']" id="PORFilter"
                    v-model="Filter.PORFilter" option-value="pickupId" option-text="pickupLocation" placeholder="All"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>POL</label>
                  <model-list-select :list="$store.getters['common/getAllPOLList']" id="POLFilter"
                    v-model="Filter.POLFilter" option-value="pickupId" option-text="pickupLocation" placeholder="All"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>POD</label>
                  <model-list-select :list="$store.getters['common/getAllPODList']" id="PODFilter"
                    v-model="Filter.PODFilter" option-value="pickupId" option-text="pickupLocation" placeholder="All"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>FPOD</label>
                  <model-list-select :list="$store.getters['common/getAllLocationDetailsFinalList']" id="FPODFilter"
                    v-model="Filter.FPODFilter" option-value="pickupId" option-text="pickupLocation" placeholder="All"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>

                <b-col md="3">
                  <label>Common Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Common Filter"
                    id="commonFilter" name="commonFilter" autocomplete="off" v-model="Filter.commonFilter"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" />
                </b-col>

                <b-col md="3">
                  <label>
                    <b> Created User </b>
                  </label>
                  <model-list-select :list="$store.getters['common/getAllUserList']" id="createdByFilter"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" v-model="Filter.createdByFilter"
                    option-value="userId" option-text="employeeName" placeholder="Select Created User" />
                </b-col>

                <b-col md="3">
                  <label>
                    <b> Approver User </b>
                  </label>
                  <model-list-select :list="$store.getters['common/getAllUserList']" id="approverByFilter"
                    @input="getPaymentList('Normal', '0', '0', '1', '1')" v-model="Filter.approverByFilter"
                    option-value="userId" option-text="employeeName" placeholder="Select Approver User" />
                </b-col>

                <b-col md="12" class="mt-2">
                  <b-button size="sm" style="margin-left: auto" class="ml-1 pull-right" @click="clearFilter"
                    variant="outline-danger">Reset</b-button>
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="table-responsive tableMain gutr" ref="scrollArea" @scroll="handleScroll">
              <b-table show-empty stacked="md" responsive :items="paymentList" :fields="PaymentFields"
                primary-key="id_email_section" :per-page="pagination.perPage" :filter="filter" :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered"
                class="position-relative">

                <template slot="checkbox" slot-scope="row0">
                  <div class="d-flex align-items-center gap-2">
                    <b-button @click="onToggleDetails(row0)" class="mr-2" size="xs" style="font-size: 0.675rem"
                      variant="outline-info">
                      <md-icon>{{ row0.detailsShowing ? "expand_less" : "expand_more" }}</md-icon>
                      {{ row0.detailsShowing ? "Hide More" : "Show More" }}
                    </b-button>

                    <b-form-checkbox v-model="selectedCheckBoxRows" :value="{
                      ApeId: row0.item.fk_ape_id,
                      JobId: row0.item.JobId,
                      JobNo: row0.item.JobNo,
                      TransactionNo: row0.item.TransactionNo,
                    }" />
                  </div>
                </template>
                <template slot="SN" slot-scope="row0">
                  <span>
                    {{
                      row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage
                    }}
                  </span>
                </template>
                <template slot="TransDet" slot-scope="row1">
                  <strong>Trans No:</strong> {{ row1.item.TransactionNo }}<br />
                  <strong>Status:</strong>
                  <b-badge
                    :variant="row1.item.approval_status === 'APPROVED' ? 'success' : (row1.item.approval_status === 'REJECTED' ? 'danger' : 'warning')">
                    {{ row1.item.approval_status || '-' }}
                  </b-badge><br />
                  <strong>Requested:</strong> {{ row1.item.approval_requested_at || '-' }}
                  <Assignment-Summary v-if="$sessionsStorage.get('is_Mobile') != 'port'"
                    :title="'Shipment Summary Tracking - '" :assign_date="row1.item.JobDate"
                    :assign_job_type="row1.item.JobType" :assign_raised_from="'Raised From: ' + row1.item.JobRaisedFrom"
                    :assign_raised_by="'Raised By: ' + row1.item.raisedBy" :fk_all_module_id="row1.item.JobId"
                    :jb_series="row1.item.JobNo" :fk_client_id="''" :fk_pod_id="''" />
                  <b-button v-if="$sessionsStorage.get('is_Mobile') != 'port'" size="sm" class="mt-2"
                    style="font-size: 0.675rem" @click="showDocModal(row1.item)" variant="outline-info">Summary &
                    Documents</b-button>
                </template>

                <template slot="JobDet" slot-scope="row1">
                  <strong>Job No:</strong> {{ row1.item.JobNo }}<br />
                  <strong>Job Date:</strong> {{ row1.item.JobDate }}<br />
                  <strong>Raised By:</strong> {{ row1.item.JobRaisedBy }}<br />
                  <strong>Raised From:</strong> {{ row1.item.JobRaisedFrom }}<br />
                  <strong>Type:</strong> {{ row1.item.ModuleType }} / {{ row1.item.JobType }}
                  <AssignmentSplitMergeSummary v-if="row1.item.JobId"
                    :PMC_title="'Assignment Split/Merge/Move Summary Job No - ' + row1.item.JobNo"
                    :PMC_JOBID="String(row1.item.JobId)" :PMC_JOBNO="row1.item.JobNo" :PMC_JOBDATE="row1.item.JobDate"
                    :PMC_JOBTYPE="row1.item.JobType" :PMC_AgentType="''" :PMC_Client="row1.item.Client"
                    :PMC_Sline="row1.item.Sline" />
                  <JobWisePaymentsDetails v-if="row1.item.JobId" :allModuleId="Number(row1.item.JobId)"
                    :JobNo="row1.item.JobNo" />
                </template>
                <template slot="LocDet" slot-scope="row1">
                  <span v-if="row1.item.POR">POR:{{ row1.item.POR }}<br /></span>
                  <span v-if="row1.item.POL">POL:{{ row1.item.POL }}<br /></span>
                  <span v-if="row1.item.POD">POD:{{ row1.item.POD }}<br /></span>
                  <span v-if="row1.item.FPOD">FPOD:{{ row1.item.FPOD }}<br /></span>
                  <span v-if="row1.item.PICK">PICK:{{ row1.item.PICK }}<br /></span>
                  <span v-if="row1.item.HAND">HAND:{{ row1.item.HAND }}<br /></span>
                  <span v-if="row1.item.STUFF">STUFF:{{ row1.item.STUFF }}<br /></span>
                </template>

                <template slot="PayDet" slot-scope="row1">
                  <span v-if="row1.item.inv_amt">Inv Amt:{{ row1.item.inv_amt }}<br /></span>
                  <span v-if="row1.item.currencyCode">Currency:{{ row1.item.currencyCode }}<br /></span>
                  <span v-if="row1.item.ledger">Particulars:{{ row1.item.ledger }}<br /></span>
                  <span v-if="row1.item.nature_name">NOE:{{ row1.item.nature_name }}<br /></span>
                  <span v-if="row1.item.sc_category">Bill of Shipper:{{ row1.item.sc_category }}<br /></span>
                  <span v-if="row1.item.selling_amt">Selling Amt:{{ row1.item.selling_amt }}<br /></span>
                  <div v-if="row1.item.inv_doc">
                    <span v-for="(doc, idx) in row1.item.inv_doc.split(',')" :key="idx" class="d-inline-block mb-1">
                      <b-button size="xs" style="font-size: 0.675rem" variant="warning" :href="`${docURL}${doc.trim()}`"
                        target="_blank" rel="noopener">
                        View Doc {{ row1.item.inv_doc.includes(',') ? idx + 1 : '' }}
                      </b-button>
                    </span>
                    <br />
                  </div>
                </template>

                <!-- Expandable Row for Additional Details -->
                <template slot="row-details" slot-scope="row4">
                  <b-card style="background: whiteSmoke">
                    <b-row>
                      <b-col cols="12" class="mb-2" v-if="row4.item._childrenLoading">
                        <span>Loading child items...</span>
                      </b-col>
                      <b-col cols="12" class="mb-2"
                        v-if="(row4.item.children && row4.item.children.length) || (row4.item.getItems && row4.item.getItems.length)">
                        <!-- EXPENSE -->
                        <b-table v-if="String(row4.item.payment_type).toLowerCase() === 'expense'" small
                          :items="row4.item.children && row4.item.children.length ? row4.item.children : (row4.item.getItems || [])"
                          :fields="[
                            { key: 'inv_date', label: 'Inv Date' },
                            { key: 'nature_of_expense_relation.nature_name', label: 'NOE' },
                            { key: 'sc_remark', label: 'Remarks' }
                          ]" head-variant="light">
                          <!-- Single Doc URL button -->
                          <template slot="cell(inv_doc_url)" slot-scope="c">
                            <div v-if="c.item && c.item.inv_doc_url">
                              <b-button size="xs" style="font-size: 0.675rem" variant="warning"
                                :href="String(c.item.inv_doc_url).startsWith('http') ? c.item.inv_doc_url : `${docURL}${c.item.inv_doc_url}`"
                                target="_blank" rel="noopener">
                                View Doc
                              </b-button>
                            </div>
                            <div v-else>-</div>
                          </template>

                        </b-table>

                        <!-- ADDITIONAL TASK -->
                        <b-table v-else-if="String(row4.item.payment_type).toLowerCase() === 'additional task'" small
                          :items="row4.item.children && row4.item.children.length ? row4.item.children : (row4.item.getItems || [])"
                          :fields="[
                            { key: 'inv_date', label: 'Inv Date' },
                            { key: 'inv_amt', label: 'Inv AMT' },
                            { key: 'ledgermaster_relation.ledger', label: 'Particular' },
                            { key: 'master_currency_relation.currencyCode', label: 'Currency' },
                            { key: 'sc_category', label: 'Bill To Customer' },
                            { key: 'selling_amt', label: 'Selling AMT' },
                            { key: 'sc_remark', label: 'Remarks' }
                          ]" head-variant="light">

                        </b-table>
                      </b-col>
                    </b-row>
                  </b-card>
                </template>

                <template slot="PeopleDet" slot-scope="row1">
                  <strong>Requester:</strong> {{ row1.item.requestBy || '-' }}<br />
                  <strong>Approver:</strong> {{ row1.item.approverBy || '-' }}

                  <InvExpSummary v-if="row1.item.JobId" :PMC_title="'Inv Exp Summary Job No - ' + row1.item.JobNo"
                    :PMC_JOBID="String(row1.item.JobId)" :PMC_JOBNO="row1.item.JobNo" :PMC_JOBDATE="row1.item.JobDate"
                    :PMC_JOBTYPE="row1.item.JobType" :PMC_AgentType="''" :PMC_Client="row1.item.Client"
                    :PMC_Sline="row1.item.Sline" />
                  <ContainerSummary v-if="row1.item.JobId" :PMC_title="'Container Summary Job No - ' + row1.item.JobNo"
                    :PMC_JOBID="String(row1.item.JobId)" :PMC_JOBNO="row1.item.JobNo" :PMC_JOBDATE="row1.item.JobDate"
                    :PMC_JOBTYPE="row1.item.JobType" :PMC_AgentType="''" :PMC_Client="row1.item.Client"
                    :PMC_Sline="row1.item.Sline" />
                </template>

                <template slot="TimeDet" slot-scope="row1">
                  <strong>Requested:</strong> {{ row1.item.approval_requested_at || '-' }}<br />
                  <strong>Acted:</strong> {{ row1.item.acted_at || '-' }}<br />
                  <strong>Completed:</strong> {{ row1.item.approval_completed_at || '-' }}
                </template>

                <template slot="actions" slot-scope="row1">
                  <div class="d-flex align-items-center justify-content-end">
                    <b-dropdown right
                      :variant="isPending(row1.item) ? 'warning' : (isRejectedOrCancelled(row1.item) ? 'secondary' : 'outline-secondary')"
                      size="sm" toggle-class="btn-xs rounded-pill px-2"
                      v-if="row1.item.approval_status === 'PENDING' || row1.item.approval_status === 'REJECTED' || row1.item.approval_status === 'CANCELLED'">
                      <b-dropdown-item v-if="row1.item.approval_status === 'PENDING'"
                        @click="openAction(row1.item, 'APPROVE')">Approve</b-dropdown-item>
                      <b-dropdown-item v-if="row1.item.approval_status === 'PENDING'"
                        @click="openAction(row1.item, 'REJECT')">Reject</b-dropdown-item>
                      <b-dropdown-item v-if="row1.item.approval_status === 'PENDING'"
                        @click="openAction(row1.item, 'CANCEL')">Cancel</b-dropdown-item>
                      <b-dropdown-item
                        v-if="row1.item.approval_status === 'REJECTED' || row1.item.approval_status === 'CANCELLED'"
                        @click="openAction(row1.item, 'RESEND')">Resend</b-dropdown-item>
                    </b-dropdown>
                  </div>
                </template>
              </b-table>
              <!-- Infinite scroll sentinel -->
              <div ref="infiniteSentinel" style="height: 1px;"></div>
            </div>
            <div>
              <b-pagination limit="25" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
                :total-rows="totalData" @change="onPageChange($event)"></b-pagination>
            </div>
          </div>
        </div>
      </b-card-text>
    </b-card>
    <b-modal id="approval-action-modal" v-model="actionModal.show" :title="actionModal.title" hide-footer>
      <b-form @submit.prevent="submitAction">
        <b-form-group label="Remark / Reason">
          <b-form-textarea v-model="actionModal.remark" rows="4" max-rows="6"
            placeholder="Enter reason (required)"></b-form-textarea>
        </b-form-group>
        <div class="d-flex justify-content-end">
          <b-button variant="outline-secondary" class="mr-2" @click="actionModal.show = false">Close</b-button>
          <b-button variant="primary" type="submit" :disabled="!actionModal.remark || isLoading">
            {{ isLoading ? 'Please wait...' : 'Submit' }}
          </b-button>
        </div>
      </b-form>
    </b-modal>
    <b-modal class="modal-dialog-doc" size="xl" no-close-on-esc no-close-on-backdrop ref="doc-modal" hide-footer
      :title="'Assignment Summary & Documents - ' + JOBSERIES">
      <div v-if="ALLMODULE">
        <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
      </div>
      <b-button class="mt-3" variant="outline-danger" block @click="hideDocModal">Close
      </b-button>
    </b-modal>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import CustomLoader from "../common/customLoader.vue";
import { DateFormat, selectDateFormat, excelSerialToDate } from "../../helper/filters";
import { lastVisitPage, globalPermissionStatus } from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import Multiselect from "vue-multiselect";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant";
import { read, utils, writeFile } from "xlsx";
import PaymentRequestService from "../../services/PaymentRequestService";
import { exportPaymentApprovalToExcel } from "../../helper/ExcelExportHelper";

import DocForm from "../allModuleForm/docLibrary.vue";
import BookingTrack from "../consoleBooking/bookingTrack.vue";
import JobWisePaymentsDetails from "../common/jobWisePaymentsDetails.vue";
import AssignmentSplitMergeSummary from "../common/AssignmentSplitMergeSummary.vue";
import ContainerSummary from "../common/moduleBasedContaierSummary.vue";
import InvExpSummary from "../common/moduleBasedInvExpSummary.vue";
import AssignmentSummary from "../common/assignmentSummary.vue";

export default {
  // Component logic for Tab 1
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
 this.$store.dispatch("setCurrentRoute", this.$route.path);
    const storePromises = [
      this.$store.dispatch(
        "common/setAllUserList",
        JSON.stringify({
          itemCode: "GET_USERLIST_Data",
        })
      ),
      this.$store.dispatch(
        "common/setAllBranchList",
        JSON.stringify({
          filter: "BranchList",
          active: "all",
        })
      ),
      this.$store.dispatch("common/setAllAgentColoaderList"),
      this.$store.dispatch(
        "common/setAllClientList",
        JSON.stringify({ itemCode: "ClientList" })
      ),
      this.$store.dispatch(
        "common/setAllShippingLineList",
        JSON.stringify({ itemCode: "ShippingLineList" })
      ),
      this.$store.dispatch(
        "common/setAllLocationDetailsFinalList",
        JSON.stringify({ itemCode: "LocationDetailsFinalList" })
      ),
      this.$store.dispatch(
        "common/setAllPORList",
        JSON.stringify({ itemCode: "PORList" })
      ),
      this.$store.dispatch(
        "common/setAllPODList",
        JSON.stringify({ itemCode: "PODList" })
      ),
      this.$store.dispatch(
        "common/setAllPOLList",
        JSON.stringify({ itemCode: "POLList" })
      ),

      this.$store.dispatch(
        "common/setAllCurrencyList",
        JSON.stringify({ Currency: "Currency_DropDown" })
      ),

    ];
    // Function to introduce a delay
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    // Wait for all store actions to complete
    Promise.all(storePromises)
      .then(() => delay(5000)) // Wait for 5 seconds
      .then(() => {
        // After the delay, execute the next function
          if (globalPermissionStatus("Expense Access")) {
        this.$store.dispatch("setCurrentRoute", "/payment/approval");
        if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
          this.fetchLastPage(this.lastVisitPage);
        } else {
          this.getPaymentList("Normal", "0", "0", "1", "1");
        }
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
      })
      .catch((error) => {
        console.error("Error dispatching store actions:", error);
      });

  },
  mounted() { },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() { },

  destroyed() { },
  data() {
    return {

      ALLMODULE: "",
      JOBSERIES: "",
      errMSG: "",
      docURL: URL_BASE_DOC,
      selectDateFormat,
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      ExcelBtnName: "Export As Excel",
      ExcelBtnName1: "Export And Import",
      visible: false,
      paymentList: [],
      totalData: 0,

      payList: [
        {
          payVal: "VIA VATECH",
          payText: "VIA VATECH",
        },
        {
          payVal: "ONLINE",
          payText: "ONLINE",
        },
      ],
      payment: {
        paymentMode: "VIA VATECH",
        paymentAmount: "",
        paymentRef: "",
        paymentDate: "",
      },

      errorCustomPaymentValidation: {
        paymentMode: "",
        paymentAmount: "",
        paymentRef: "",
        paymentDate: "",
      },

      arrayErrorCustomValidation: [
        {
          paymentMode: "Select Payment Mode",
          paymentAmount: "Enter Payment Amount",
          paymentRef: "Enter Payment Reference No",
          paymentDate: "Enter Payment Date",
        },
      ],
      validate: true,

      // Date format for datepickers
      confirmExcelFields: [
        { key: 'SN', label: 'SN' },
        { key: 'paymentModuleType', label: 'Module' },
        { key: 'JobNo', label: 'Job No.' },
        { key: 'InvNumber', label: 'Invoice No.' },
        { key: 'InvAmt', label: 'Amount' },
        { key: 'payReference', label: 'Pay Reference' },
        { key: 'paidAmount', label: 'Pay Amount' },
        { key: 'payDate', label: 'Pay Date' },
      ],
      excelRows: [],
      dateFormat: { year: "numeric", month: "short", day: "numeric" },
      confirmFields: [
        { key: 'SN', label: 'SN' },
        { key: 'paymentModuleType', label: 'Module' },
        { key: 'JobNo', label: 'Job No.' },
        { key: 'InvNumber', label: 'Invoice No.' },
        { key: 'InvAmt', label: 'Amount' }
      ],
      isBulkPaymentProcessing: false,
      selectedCheckBoxRows: [],
      actionModal: {
        show: false,
        action: '',
        title: 'Take Action',
        remark: '',
        row: null,
      },
      PaymentFields: [
        { key: 'checkbox', mainkey: 'checkbox', label: 'Select', sortable: false, sortDirection: 'ASC', table: 'A.' },
        { key: 'SN', mainkey: 'SN', label: 'SN.', sortable: true, sortDirection: 'ASC', table: 'A.' },

        { key: 'TransDet', mainkey: 'TransDet', label: 'Transaction', sortable: false, table: 'C.' },
        { key: 'JobDet', mainkey: 'JobDet', label: 'Job', sortable: false, table: 'C.' },
        { key: 'LocDet', mainkey: 'LocDet', label: 'Location', sortable: false, table: 'C.' },
        { key: 'PayDet', mainkey: 'PayDet', label: 'Payment', sortable: false, table: 'C.' },
        { key: 'PeopleDet', mainkey: 'PeopleDet', label: 'People', sortable: false, table: 'C.' },
        { key: 'TimeDet', mainkey: 'TimeDet', label: 'Timeline', sortable: false, table: 'C.' },
        { key: 'remark', mainkey: 'remark', label: 'Remark', sortable: true, sortDirection: 'ASC', table: 'C.' },
        { key: 'actions', mainkey: 'actions', label: 'Actions', sortable: false, table: 'C.' },
      ],

      pagination: {
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 20, 50],
      },
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      payTypeOptions: [
        {
          text: "",
          value: "All",
        },
        {
          Val: "0",
          Text: "Sline",
        },
        {
          Val: "1",
          Text: "Expense",
        },
        {
          Val: "2",
          Text: "Additional Task",
        },
      ],

      moduleOptions: [
        {
          Val: "0",
          Text: "Normal",
        },
        {
          Val: "1",
          Text: "consolidation",
        },
        {
          Val: "2",
          Text: "MISC",
        },
        {
          Val: "3",
          Text: "YARD",
        },
        {
          Val: "4",
          Text: "IB",
        },
      ],
      shipmentTypeList: [
        {
          text: "Sea",
          value: "Sea",
        },
        {
          text: "Air",
          value: "Air",
        },
      ],
      statusList: [
        {
          text: "",
          value: "All",
        },
        {
          text: "PENDING",
          value: "PENDING",
        },
        {
          text: "APPROVED",
          value: "APPROVED",
        },
        {
          text: "REJECTED",
          value: "REJECTED",
        },
        {
          text: "CANCELLED",
          value: "CANCELLED",
        },
      ],
      transportTypeList: [
        {
          text: "EXPORT",
          value: "EXPORT",
        },
        {
          text: "IMPORT",
          value: "IMPORT",
        },
        {
          text: "CROSS COUNTRY",
          value: "CRC",
        },
      ],
      dateTypeList: [
        {
          text: "Job",
          value: "1",
        },
        {
          text: "Payment Request Date",
          value: "2",
        },
      ],
      Filter: {
        ModuleTypeFilter: "0",
        PaymentTypeFilter: "2",
        DateTypeFilter: "2",
        JobNoFilter: "",
        TransactionNoFilter: "",
        clientFilter: "",
        slineFilter: "",
        TransportTypeFilter: "",
        ShipemntTypeFilter: "",
        PORFilter: "",
        POLFilter: "",
        PODFilter: "",
        FPODFilter: "",
        statusFilter: "PENDING",
        commonFilter: "",
        createdByFilter: "",
        approverByFilter: "",
        branchFilter: "",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      },
      //Added By Priyanshu Singh Multi Select Start

      openLeft: "left",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      isLoading: false,
      generateExcel: "0",
      ExpImpType: "0",
      isSubmited: false,
      isFileLoading: false,
      // Infinite scroll flags
      isInfiniteAppend: false,
      hasMore: true,
      scrollThreshold: 200,
      _lastLoadAt: 0,
    };
  },

  components: {
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,

    MultiSelect,
    Multiselect,

    DocForm,
    BookingTrack,
    JobWisePaymentsDetails,
    AssignmentSplitMergeSummary,
    ContainerSummary,
    InvExpSummary,
    AssignmentSummary,
  },
  computed: {
  },
  watch: {},
  mounted() {
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    // Setup IntersectionObserver on sentinel for reliable triggering
    this.$nextTick(() => {
      const rootEl = this.$refs && this.$refs.scrollArea ? this.$refs.scrollArea : null;
      const sentinel = this.$refs && this.$refs.infiniteSentinel;
      if (!sentinel) return;
      const options = { root: rootEl || null, rootMargin: '0px', threshold: 0.1 };
      this._io = new IntersectionObserver((entries) => {
        entries.forEach(e => {
          if (e.isIntersecting && !this.isLoading && this.hasMore) {
            this.loadMore();
          }
        });
      }, options);
      this._io.observe(sentinel);
    });
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    if (this._io) {
      try { this._io.disconnect(); } catch (e) { }
      this._io = null;
    }
  },
  methods: {
    showDocModal(item) {
      this.ALLMODULE = "";
      this.JOBSERIES = "";
      this.ALLMODULE = item.JobId;
      this.JOBSERIES = item.JobNo;
      console.log(this.ALLMODULE);
      this.$refs["doc-modal"].show();
    },
    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },
    // Helper methods for status checks (case-insensitive)
    isPending(row) {
      const s = (row && row.approval_status) ? String(row.approval_status).toUpperCase() : '';
      return s === 'PENDING';
    },
    isRejectedOrCancelled(row) {
      const s = (row && row.approval_status) ? String(row.approval_status).toUpperCase() : '';
      return s === 'REJECTED' || s === 'CANCELLED';
    },

    clearFilter() {
      this.Filter = {
        ModuleTypeFilter: "0",
        PaymentTypeFilter: "2",
        DateTypeFilter: "2",
        JobNoFilter: "",
        TransactionNoFilter: "",
        clientFilter: "",
        slineFilter: "",
        TransportTypeFilter: "",
        ShipemntTypeFilter: "",
        PORFilter: "",
        POLFilter: "",
        PODFilter: "",
        FPODFilter: "",
        statusFilter: "PENDING",
        commonFilter: "",
        createdByFilter: "",
        approverByFilter: "",
        branchFilter: "",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      };
      this.getPaymentList("Normal", "0", "0", "1", "1");
    },
    getCurrentLastDate() {
      var today = new Date();

      // Subtract 1 day from today to get the previous day
      var previousDay = new Date();
      previousDay.setDate(today.getDate() - 1);

      // Format yesterday's date (DD/MM/YYYY)
      var prev_dd = String(previousDay.getDate()).padStart(2, "0");
      var prev_mm = String(previousDay.getMonth() + 1).padStart(2, "0");
      var prev_yyyy = previousDay.getFullYear();
      var startDate = `${prev_yyyy}/${prev_mm}/${prev_dd}`; // 11/02/2025

      // Format today's date (DD/MM/YYYY)
      var today_dd = String(today.getDate()).padStart(2, "0");
      var today_mm = String(today.getMonth() + 1).padStart(2, "0");
      var today_yyyy = today.getFullYear();
      var endDate = `${today_yyyy}/${today_mm}/${today_dd}`; // 12/02/2025

      // Set startDate and endDate
      this.startDate = startDate;
      this.Filter.dateRange = {
        startDate: startDate, // 11/02/2025
        endDate: endDate,     // 12/02/2025
      };
    },
    getPaymentList(type, filterIdD, CURRENT, SEARCH, pageNumber) {
      if (!this.isInfiniteAppend) {
        this.totalData = 0;
        this.paymentList = [];
        this.hasMore = true;
      }
      let payload = {};
      if (type == "Normal") {
        this.isLoading = true;
      }
      payload = {
        isAll:0,
        type: type,
        DCfilterId: filterIdD,
        searchVal: this.filter,
        DCfilterId: filterIdD,
        fromSearch: SEARCH,
        // currentPage: CURRENT,
        currentPage: this.pagination.currentPage,
        page: this.pagination.currentPage,
        perPage: this.pagination.perPage,
        pageSize: this.pagination.perPage,
        filter: this.Filter,
        moduleTypeFilter: this.Filter.moduleTypeFilter,
        paymentTypeFilter: this.Filter.paymentTypeFilter,
        dateTypeFilter: this.Filter.dateTypeFilter,
        JobNoFilter: this.Filter.JobNoFilter,
        TransactionNoFilter: this.Filter.TransactionNoFilter,
        clientFilter: this.Filter.clientFilter,
        slineFilter: this.Filter.slineFilter,
        transportTypeFilter: this.Filter.transportTypeFilter,
        shipmentTypeFilter: this.Filter.shipmentTypeFilter,
        PORFilter: this.Filter.PORFilter,
        POLFilter: this.Filter.POLFilter,
        PODFilter: this.Filter.PODFilter,
        FPODFilter: this.Filter.FPODFilter,
        statusFilter: this.Filter.statusFilter,
        commonFilter: this.Filter.commonFilter,
        createdByFilter: this.Filter.createdByFilter,
        approverByFilter: this.Filter.approverByFilter,
        branchFilter: this.Filter.branchFilter,
        startDate: this.Filter.startDate,
        endDate: this.Filter.endDate,
        dateRange: this.Filter.dateRange,

        generateExcel: this.generateExcel,
        isList:1,

      };
      if (this.Filter.fk_ape_id) payload.fk_ape_id = this.Filter.fk_ape_id
      if (this.Filter.approval_status) payload.approval_status = this.Filter.approval_status
      // Set responseType to 'blob' if generating Excel
      const config = this.generateExcel == "1" ? { responseType: "blob" } : {};
      PaymentRequestService.listApprovals(payload, config)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            console.log("getPurchaseExpense data", data);
            if (this.generateExcel == "1") {
              // Handle file download
              const blob = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "get-Sales-Payment-panel-report.xlsx"); // Specify the file name
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              this.ExcelBtnName = "Export As Excel";
              this.ExcelBtnName1 = "Export And Import";
              this.generateExcel = "0";
              this.ExpImpType = "0";
              this.getPaymentList("Normal", "0", "0", "1", "1");
            } else {
              if (data.data.length > 0) {
                const pageItems = Array.isArray(data.data) ? data.data : [];
                this.paymentList = this.isInfiniteAppend ? this.paymentList.concat(pageItems) : pageItems;

                const apiTotal = data.pagination && Number(data.pagination.totalCount);
                if (!Number.isNaN(apiTotal) && apiTotal > 0) {
                  this.totalData = apiTotal;
                  this.pagination.totalRows = apiTotal;
                  // Do not override client-driven currentPage/perPage here
                  this.hasMore = this.paymentList.length < this.totalData;
                } else {
                  // Fallback: decide hasMore by page size if total not provided
                  this.hasMore = pageItems.length === this.pagination.perPage;
                  this.totalData = this.paymentList.length;
                  this.pagination.totalRows = this.totalData;
                }
              } else {
                // No items returned => no more pages
                this.hasMore = false;
              }
            }
          }
          this.isLoading = false;
          this.isInfiniteAppend = false;
          // If content doesn't fill the scroll container yet, try loading more
          this.$nextTick(() => {
            const el = this.$refs && this.$refs.scrollArea;
            if (el && this.hasMore && (el.scrollHeight <= el.clientHeight + 1)) {
              this.loadMore();
            }
          });
        })
        .catch((error) => {
          console.log("Catch on getPaymentList Error: ", error);
        });
    },
    handleScroll() {
      if (this.isLoading || !this.hasMore) return;
      const now = Date.now();
      if (now - this._lastLoadAt < 300) return; // debounce ~300ms

      let shouldLoad = false;
      // Container-based scroll
      const el = this.$refs && this.$refs.scrollArea;
      if (el) {
        const nearBottomDiv = (el.scrollTop + el.clientHeight) >= (el.scrollHeight - this.scrollThreshold);
        if (nearBottomDiv) shouldLoad = true;
      }
      // Window-based scroll (in case the page scrolls instead of the container)
      const winNearBottom = (window.innerHeight + window.scrollY) >= (document.body.offsetHeight - this.scrollThreshold);
      if (winNearBottom) shouldLoad = true;

      if (shouldLoad) {
        this._lastLoadAt = now;
        this.loadMore();
      }
    },
    loadMore() {
      // alert("loadMore");
      if (this.isLoading || !this.hasMore) return;
      this.isInfiniteAppend = true;
      // this.pagination.currentPage = (this.pagination.currentPage || 1) + 1;
      this.getPaymentList("Normal", "0", "0", "2", String(this.pagination.currentPage));
    },
    onFiltered(filtered) {
      this.totalRows = filtered.length;
      this.pagination.currentPage = 1;
    },
    clearTimeout() { },
    goBack() {
      window.history.go(-1);
    },

    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getPaymentList("Normal", "0", "0", "1", "1");
      }, 1000);
    },
    getReports(id, btnName) {
      this.isLoading = true;
      this.ExpImpType = "1";
      this.generateExcel = "1";
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getPaymentList("Excell", "0", "0", "1", "1");
    },
    getExpImpReports(id, btnName) {
      this.ExpImpType = "2";
      this.isLoading = true;
      this.generateExcel = "1";
      this.ExcelBtnName1 = "Downloading Please Wait .....";
      this.getPaymentList("Excell", "0", "0", "1", "1");
    },

    // Export to Excel using client-side helper
    async exportApprovalToExcelClient() {
      const payload = {
        type: 'Excel',
        currentPage: 1,
        page: 1,
        perPage: this.totalData || 10000, // Get all records
        pageSize: this.totalData || 10000,
        filter: this.Filter,
        generateExcel: '1',
        moduleTypeFilter: this.Filter.moduleTypeFilter,
        paymentTypeFilter: this.Filter.paymentTypeFilter,
        dateTypeFilter: this.Filter.dateTypeFilter,
        JobNoFilter: this.Filter.JobNoFilter,
        TransactionNoFilter: this.Filter.TransactionNoFilter,
        clientFilter: this.Filter.clientFilter,
        slineFilter: this.Filter.slineFilter,
        transportTypeFilter: this.Filter.transportTypeFilter,
        shipmentTypeFilter: this.Filter.shipmentTypeFilter,
        PORFilter: this.Filter.PORFilter,
        POLFilter: this.Filter.POLFilter,
        PODFilter: this.Filter.PODFilter,
        FPODFilter: this.Filter.FPODFilter,
        statusFilter: this.Filter.statusFilter,
        commonFilter: this.Filter.commonFilter,
        createdByFilter: this.Filter.createdByFilter,
        approverByFilter: this.Filter.approverByFilter,
        branchFilter: this.Filter.branchFilter,
        startDate: this.Filter.startDate,
        endDate: this.Filter.endDate,
        dateRange: this.Filter.dateRange,
      };

      if (this.Filter.fk_ape_id) payload.fk_ape_id = this.Filter.fk_ape_id;
      if (this.Filter.approval_status) payload.approval_status = this.Filter.approval_status;

      await exportPaymentApprovalToExcel(
        payload,
        'payment-approval.xlsx',
        true,
        // onStart
        () => {
          this.isLoading = true;
        },
        // onSuccess
        () => {
          this.isLoading = false;
          this.alert.content = 'Excel file downloaded successfully!';
          this.$refs['addPop'].open();
        },
        // onError
        (error) => {
          this.isLoading = false;
          this.alert.content = 'Failed to export Excel. Please try again.';
          this.$refs['addPop'].open();
          console.error('Export error:', error);
        }
      );
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.pagination.perPage - this.pagination.perPage;
      }
      this.getPaymentList("Normal", "0", CURRENT, "2", event);
    },
    onPageChange: function (event) {
      this.pagination.currentPage = event;
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.perPage - this.pagination.perPage;
      }
      this.getPaymentList("Normal", "0", CURRENT, "2", event);
    },
    openAction(row, action) {
      this.actionModal.row = row;
      this.actionModal.action = action;
      this.actionModal.remark = '';
      const titles = {
        APPROVE: 'Approve Request',
        REJECT: 'Reject Request',
        CANCEL: 'Cancel Request',
        RESEND: 'Resend Request',
      };
      this.actionModal.title = titles[action] || 'Take Action';
      this.actionModal.show = true;
    },
    submitAction() {
      if (!this.actionModal.row || !this.actionModal.action || !this.actionModal.remark) return;
      this.isLoading = true;
      const r = this.actionModal.row;
      // Flexible payload to support approve/reject/cancel/resend
      const payload = {
        pea_id: r.pea_id,
        fk_ape_id: r.fk_ape_id,
        next_status: this.actionModal.action === 'RESEND' ? 'PENDING' : this.actionModal.action,
        remark: this.actionModal.remark,
      };
      PaymentRequestService.upsertApproval(payload)
        .then(({ data }) => {
          this.alert.content = (data && (data.message || data.msg)) ? (data.message || data.msg) : 'Action completed';
          this.$refs['addPop'].open();
          this.actionModal.show = false;
          this.getPaymentList('Normal', '0', '0', '1', '1');
        })
        .catch(() => { /* handle error silently */ })
        .finally(() => { this.isLoading = false; });
    },
    onToggleDetails(rowCtx) {
      const wasShowing = rowCtx.detailsShowing;
      rowCtx.toggleDetails();
      if (!wasShowing && !rowCtx.item._childrenLoaded) {
        const items = Array.isArray(rowCtx.item.getItems) ? rowCtx.item.getItems : [];
        this.$set(rowCtx.item, 'children', items);
        this.$set(rowCtx.item, '_childrenLoaded', true);
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// PaymentApprovalList.vue?362552de